import PropTypes from 'prop-types';

const displayName = 'InvoicePage';
const propTypes = {
  getInvoice: PropTypes.func.isRequired,
  setLoading: PropTypes.func,
  setErrorState: PropTypes.func,
  invoiceData: PropTypes.object,
  intl: PropTypes.object,
};
const defaultProps = {};

export default { displayName, propTypes, defaultProps };
